import { render, staticRenderFns } from "./AppPageView.vue?vue&type=template&id=d2e6360c&"
import script from "./AppPageView.vue?vue&type=script&lang=js&"
export * from "./AppPageView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports